import { environment } from 'src/environments/environment';
import { APPMODE } from 'src/environments/appmode.enum';

/**
 * First path segment of every backoffice and account-management route in
 * `app-routing.module.ts` and `admin-routing.ts` (card #11440). The combined
 * web build serves the backoffice and the customer UI from one origin, and
 * everything it serves outside this list is the customer UI: the store pages,
 * the payment and voucher flows, reservations and the kiosk display.
 */
const BACKOFFICE_ROOT_PATHS = [
  'manager',
  'hubrise-user-login',
  'login',
  'user-login',
  'register',
  'register-user-details',
  'partners',
  'account',
  'password',
  'stripe',
  'not-found',
  'error',
];

/** The Customer, Template and Kiosk builds only ever render the customer UI. */
export function isCustomerUiAppMode(): boolean {
  return (
    environment.mode === APPMODE.Customer ||
    environment.mode === APPMODE.Template ||
    environment.mode === APPMODE.Kiosk
  );
}

/**
 * Whether `url` — a router URL or a `location.pathname` — addresses the
 * customer UI rather than the backoffice. Decided on the first path segment
 * alone so the answer never waits on a store to load; a session can expire
 * mid-load.
 */
export function isCustomerUiPath(url: string): boolean {
  const rootPath = (url || '')
    .split('#')[0]
    .split('?')[0]
    .split('/')
    .filter((segment) => !!segment)[0];
  return !BACKOFFICE_ROOT_PATHS.includes(rootPath);
}
